import React, { Component } from "react"

//component
import { sideList } from "./Menu"

//material ui
import Drawer from "@material-ui/core/Drawer"

class MenuDrawers extends Component {
	constructor(props) {
		super(props)
		this.state = {
			projectopen: false,
			Translateopen: false,
			Profileopen: false
		}
	}

	handleClick = (event, value) => {
		if (value === "project") {
			this.setState(state => ({ projectopen: !state.projectopen }))
		} else if (value === "Translate") {
			this.setState(state => ({ Translateopen: !state.Translateopen }))
		} else if (value === "Profile") {
			this.setState(state => ({ Profileopen: !state.Profileopen }))
		}
	}

	render() {
		const {
			classes,
			left,
			toggleDrawer,
			t,
			i18n,
			user,
			handleLogout
		} = this.props
		let { projectopen, Translateopen, Profileopen } = this.state
		return (
			<Drawer open={left} onClose={toggleDrawer("left", false)}>
				{sideList(
					classes,
					t,
					projectopen,
					Translateopen,
					Profileopen,
					this.handleClick,
					toggleDrawer,
					i18n,
					user,
					handleLogout
				)}
			</Drawer>
		)
	}
}
export default MenuDrawers
